import React, { useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import logo from "../../../../assets/assests/logo.png";
import config from "../../../../config";
const LoginScreen = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validationSchema = Yup.object({
    username: Yup.string().required("Username is required."),
    password: Yup.string().required("Password is required."),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      username: "",
      password: "",
    },
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const response = await axios.post(
          `${config.baseUrl}/Portal/login`,
          values,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200 && response.data?.responseCode === "200") {
          const token = response.data.body.authToken;
          const userInfo = response.data.body.userInfo;

          if (token) {
            localStorage.setItem("accessToken", token);
            localStorage.setItem("userName", response.data.body.userName);
            localStorage.setItem("userId", response.data.body.id);
            localStorage.setItem("userInfo", JSON.stringify(userInfo));

            toast.success(
              `${response.data.responseDescription}:User logged in successfully.`
            );
            setTimeout(() => {
              navigate("/");
            }, 1000);
          } else {
            toast.error("Login failed");
          }
        } else {
          toast.error(
            response.data?.statusMessage ||
              "Login failed. Please check your credentials."
          );
        }
      } catch (error) {
        console.error("Login error:", error);
        if (error.response?.data?.statusMessage) {
          toast.error(error.response.data.statusMessage);
        } else {
          toast.error("Login failed due to a network issue. Please try again.");
        }
      } finally {
        setLoading(false);
      }
    },
  });



  
  return (
    <>
      <div className="auth-page">
        <div className="container">
          <div className="logo-section">
            <img src={logo} alt="Logo" />
          </div>

          <div className="content-wrapper">
            <div className="sign-in-box">
              <h2>Log In</h2>
              <p className="create-account"></p>
              <form onSubmit={formik.handleSubmit}>
                <div className="input-group">
                  <label className="">Username </label>
                  <InputText
                    keyfilter={/^[a-zA-Z\s]*$/}
                    className="auth-welcome"
                    placeholder="Enter username"
                    maxLength={"20"}
                    id="username"
                    name="username"
                    value={formik.values.username}
                    onChange={formik.handleChange}
                  />
                  {formik.touched.username && formik.errors.username ? (
                    <div className="error">{formik.errors.username}</div>
                  ) : null}
                </div>
                <div className="input-group password">
                  <label className="">Password</label>
                  <Password
                    className="auth-welcome"
                    placeholder="Enter password"
                    type="password"
                    maxLength={"10"}
                    id="password"
                    name="password"
                    value={formik.values.password}
                    toggleMask
                    feedback={false}
                    onChange={formik.handleChange}
                    onKeyUp={(e) => {
                      const value = e.target.value.replace(/\s/g, "");
                      formik.setFieldValue("password", value);
                    }}
                  />
                  {formik.touched.password && formik.errors.password ? (
                    <div className="error">{formik.errors.password}</div>
                  ) : null}
                </div>
                <div className="button-cont">
                  <Button
                    type="submit"
                    className="p-button sign-in-button"
                    loading={loading}
                    disabled={loading}
                    label={"Log In"}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginScreen;
